<div *ngIf="commonServicePlanFeatures?.length" class="ds-grid container-fluid">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-5 col-md-4 col-lg-3 text-center pb-6 pb-sm-0">
      <img alt="folder with checkmark" src="../../../../../assets/images/folder-with-checkmark.svg">
    </div>
    <div class="col-12 col-sm-6">
      <h3 class="pb-4 ds-heading--s mb-0">{{'productDetails.allPlansInclude' | cxTranslate}}</h3>
      <dcp-checkmark-list [entries]="commonServicePlanFeatures"></dcp-checkmark-list>
    </div>
  </div>
  <div class="w-100 separator common-features-separator"></div>
</div>
